<template>
  <nav class="nav-expandable">
    <ul class="nav-expandable__list">
      <slot />
    </ul>
  </nav>
</template>

<script>
import { provide, readonly, ref } from 'vue';
export default {
  setup() {
    const activeItem = ref('');

    const updateActiveItem = value => {
      activeItem.value = value;
    };

    provide('activeItem', readonly(activeItem));
    provide('updateActiveItem', updateActiveItem);
  },
};
</script>
